<template>
  <div>
    <v-toolbar class="my-5">
      <v-toolbar-title>{{ $t('APARTMENTS.ITEMS') }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        v-if="selectedBuildings.length === 1"
        dark
        color="indigo"
        @click="apartmentDialogCreate = true"
      >
        <v-icon left>mdi-plus</v-icon>
        {{ $t('ITEM.NEW') }} {{ $t('APARTMENTS.ITEM') }}
      </v-btn>
    </v-toolbar>

    <v-dialog
      v-if="apartmentDialogCreate"
      v-model="apartmentDialogCreate"
      persistent
      max-width="400px"
    >
      <create
        :buildings="selectedBuildings"
        @refreshBuildings="refreshBuildings"
        @cancel="apartmentDialogCreate = !apartmentDialogCreate"
      ></create>
    </v-dialog>
    <v-data-table
      v-model="selectedApartments"
      :headers="headers"
      :loading="!!!apartments"
      :items="apartments"
      :sort-by="'id'"
      :sort-desc="true"
      :items-per-page="10"
      show-select
      class="elevation-1"
    >
      <template v-slot:body.prepend>
        <tr>
          <td colspan="1"></td>
          <td>
            <v-text-field
              v-model="filter.name"
              :label="$t('DATA_TABLE.FILTER')"
            ></v-text-field>
          </td>
          <td>
            <v-text-field
              v-model="filter.rooms"
              :label="$t('DATA_TABLE.FILTER')"
            ></v-text-field>
          </td>
          <td>
            <v-text-field
              v-model="filter.floor"
              :label="$t('DATA_TABLE.FILTER')"
            ></v-text-field>
          </td>
          <td>
            <v-text-field
              v-model="filter.inhabitants"
              :label="$t('DATA_TABLE.FILTER')"
            ></v-text-field>
          </td>
          <td>
            <v-select
              v-model="filter.status"
              :items="statuses"
              :label="$t('DATA_TABLE.FILTER')"
              small-chips
              dense
              clearable
            ></v-select>
          </td>

          <td colspan="1"></td>
        </tr>
      </template>

      <template v-slot:item.status="{ item }">
        {{ $t('APARTMENTS.' + item.status) }}
      </template>

      <template v-slot:item.action="{ item }">
        <div class="text-center">
          <v-list-item @click="showApartment(item)">
            <v-list-item-title>
              <v-icon class="mr-1" small>mdi-eye</v-icon>
              {{ $t('ITEM.VIEW') }}
            </v-list-item-title>
          </v-list-item>
        </div>
      </template>
    </v-data-table>
    <v-dialog
      v-if="apartmentDialogEdit"
      v-model="apartmentDialogEdit"
      persistent
      max-width="400px"
    >
      <edit
        :apartment="apartment"
        :buildings="selectedBuildings"
        @refreshBuildings="refreshBuildings"
        @cancel="apartmentDialogEdit = !apartmentDialogEdit"
      ></edit>
    </v-dialog>
    <v-dialog
      v-if="apartmentDialogShow"
      v-model="apartmentDialogShow"
      persistent
      max-width="400px"
    >
      <show
        :apartment="apartment"
        :buildings="selectedBuildings"
        @refreshBuildings="refreshBuildings"
        @cancel="apartmentDialogShow = !apartmentDialogShow"
        @edit="apartmentDialogEdit = !apartmentDialogEdit"
      ></show>
    </v-dialog>
  </div>
</template>

<script>
import Edit from '@/components/apartments/Edit';
import Show from '@/components/apartments/Show';
import Create from '@/components/apartments/Create';

export default {
  name: 'Apartment',

  components: {
    Create,
    Edit,
    Show
  },

  props: {
    apartments: {
      type: Array,
      required: true
    },
    selectedBuildings: {
      type: Array,
      required: true
    }
  },

  data: () => ({
    selectedApartments: [],
    filter: {},
    apartmentDialogCreate: false,
    apartment: null,
    apartmentDialogEdit: false,
    apartmentDialogShow: false
  }),

  computed: {
    headers() {
      return [
        {
          text: this.$t('APARTMENTS.APARTMENT_NUMBER_NAME'),
          value: 'name',
          filter: value => this.filter_column(value, 'name')
        },
        {
          text: this.$t('APARTMENTS.ROOMS'),
          value: 'rooms',
          filter: value => this.filter_column(value, 'city')
        },
        {
          text: this.$t('APARTMENTS.FLOOR'),
          value: 'floor',
          filter: value => this.filter_column(value, 'floor')
        },
        {
          text: this.$t('BUILDINGS.INHABITANTS'),
          value: 'inhabitants_count',
          filter: value => this.filter_column(value, 'inhabitants')
        },
        {
          text: this.$t('PROFILE.STATUS'),
          value: 'status',
          filter: value => this.filter_column_status(value, 'status')
        },
        { text: '', value: 'action', align: 'center' }
      ];
    },
    statuses() {
      return [this.$t('APARTMENTS.FREE'), this.$t('APARTMENTS.OCCUPIED')];
    }
  },

  watch: {
    selectedApartments: function(val) {
      this.$emit('addSelectedApartments', val);
    },
    apartments: function(val) {
      if (val.length === 0) {
        this.selectedApartments = [];
      }
    }
  },

  methods: {
    editApartment(apartment) {
      this.apartment = apartment;
      this.apartmentDialogEdit = true;
    },
    showApartment(apartment) {
      this.apartment = apartment;
      this.apartmentDialogShow = true;
    },
    refreshBuildings: function() {
      this.$emit('refreshBuildings');
    },
    filter_column(value, param) {
      value = value + ''; //  !!! null, undefined
      if (!this.filter[param]) return true;
      if (!value) return false;

      let lcValue = value.toLowerCase(); // (value + '') means value.toString()
      let lcName = this.filter[param].toLowerCase();

      return lcValue.indexOf(lcName) > -1;
    },
    filter_column_status(value, param) {
      value = this.$t('APARTMENTS.' + value);
      if (!this.filter[param]) return true;
      if (!value) return false;

      let lcValue = value.toLowerCase(); // (value + '') means value.toString()
      let lcName = this.filter[param].toLowerCase();

      return lcValue.indexOf(lcName) > -1;
    }
  }
};
</script>
